module.exports = __webpack_public_path__ + "static/media/solendi1.7f3a1cdb.jpg";